export enum IPanelViewType {
  Form = "0",
  Table = "1",
  Map = "5",
}
